import * as Yup from 'yup';

// Validation Schema for Newsletter Subscription
const newslettervalidationSchema = Yup.object({
    email: Yup.string().email('Invalid email format').required('Email is required'),
  });

  export default newslettervalidationSchema;